(function(window) {
    'use strict'

    const config = window.RT_ANALYTICS_CONFIG || {}
    const providers = config.providers || {}

    window.clmCityCodeYM = (providers.yandexMetrika || {}).counterId || ''
    window.clmCityCodeVK = (providers.vk || {}).counterId || ''
    window.clmCityCodeMail = (providers.mailRu || {}).counterId || ''
    window.clmCityId = config.cityId || ''
})(window)
